/*
* Comments about React components code split:
*
* This file contains 5 components that are used on most pages of LM/CLM/DDN. It is bundled by base:js job in assets.config.js
* Other components are only used on a few pages or not shared by 3 sites. They have their own Index.jsx file and bundle. Check the components array in assets.config.js for more information
*
* If you are creating a new component that is shared on all/most pages for LM/CLM/DDN, please include it here
* If you are creating a new component that is used on only a few pages, please create a new Index.jsx file in its folder and update the components array in assets.config.js
*
* You may want to create a new job for a specific page if that page has many extra components that aren't the below 5. Refer to articleViewPage for an example
*
* You may also want to split this file into 3 for LM/CLM/DDN in the future. If this happens, base:js job needs to be updated as well.
* The reason why LM/CLM/DDN share this file right now is that they are all using the following 5 components on most of their pages.
* For example, if a new ComponentA is created for all pages only on LM, a new ComponentB is created for all pages only on CLM, you may want to create an LM_Index.jsx with the following code
* plus ComponentA, a CLM_Index.jsx with the following code plus ComponentB, and change this file to DDN_Index.jsx
*
* This wiki page would also be helpful if you want to get a list of all routes/views of LM/CLM/DDN
* https://gitlab.labx.com/docs/frontend/-/wikis/LM-CLM-DDN-Web-Pages
*/

import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
const { register } = require("@lpm/pug-components/dist/register");

// SSR components
import CookiePolicy from "./CookiePolicy/CookiePolicy";
import HamburgerMenu from "./HamburgerMenu/HamburgerMenu";
import InlineSearch from "./InlineSearch/InlineSearch";
import Pagination from "./Pagination/Pagination";

// CSR components
import Newsletter from "./Newsletter/Newsletter";

// React SSR
register("CookiePolicy/CookiePolicy", CookiePolicy);
register("HamburgerMenu/HamburgerMenu", HamburgerMenu);
register("InlineSearch/InlineSearch", InlineSearch);
register("Pagination/Pagination", Pagination);

// React CSR
const newsletter = document.getElementById("Newsletter");

// Not react
const currentIssues = document.getElementsByClassName("CurrentIssue");
const articleGroups = document.getElementsByClassName("ArticleGroup");
const articleTabLists = document.getElementsByClassName("ArticleTabList");

if(newsletter) {
    ReactDOM.render(<Newsletter config={JSON.parse(newsletter.dataset.config)} cdnpath={newsletter.dataset.cdnpath || "/"}/>, newsletter);
}


// Not react
if(currentIssues) {
    for(let i = 0; i<currentIssues.length; i++) {
        let params = {
            isfooter: currentIssues[i].dataset.isfooter ? "true" : ""
        };
        axios.get("/api/current-issue",{
            params
        }).then((response) => {
            currentIssues[i].innerHTML = response.data;
        });

    }
}

if(articleGroups) {
    for(let i = 0; i<articleGroups.length; i++) {
        let ad = articleGroups[i].dataset.ad ? articleGroups[i].dataset.ad : "";

        let params = {
            title: articleGroups[i].dataset.title ? articleGroups[i].dataset.title : "",
            slug: articleGroups[i].dataset.slug ? articleGroups[i].dataset.slug : "",
            exclude: articleGroups[i].dataset.exclude ? articleGroups[i].dataset.exclude : "",
            ad
        };

        axios.get("/api/article-group", {
            params
        }).then((response) => {
            articleGroups[i].innerHTML = response.data;
            if(ad) {
                //init ad if one is being loaded
                let adSlots = articleGroups[i].querySelectorAll("[data-zone]");
                let loadNewAdsEvent = new CustomEvent("loadNewAds", {detail: adSlots});

                window.dispatchEvent(loadNewAdsEvent);
            }
        });
    }
}

if(articleTabLists) {
    for(let i = 0; i<articleTabLists.length; i++) {
        let params = {};
        if(articleTabLists[i].dataset.config) {
            params = JSON.parse(articleTabLists[i].dataset.config);
            params.id = articleTabLists[i].dataset.id ? articleTabLists[i].dataset.id : "";

            if(params.slugs) {
                params.slugs = params.slugs.join(",");
            }
        }

        axios.get("/api/article-tab-list", {
            params
        }).then((response) => {
            articleTabLists[i].innerHTML = response.data;
        });
    }
}
